export default "__VITE_ASSET__C3reVLPy__"